import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAuthState,
  isEmployeeDashboardPermission,
} from "@store/userData/selectors";
import { checkAuth } from "@store/userData/actions";
import { replace } from "connected-react-router";
import { useLocation } from "react-router-dom";

export enum AuthStates {
  LOADING = "LOADING",
  ALLOWED = "ALLOWED",
  DENIED = "DENIED",
}

const useAuthProvider = () => {
  const [isChecked, setIsChecked] = useState(false);
  const isAdmin = useSelector(isEmployeeDashboardPermission);
  const appState = useSelector(selectAuthState);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isChecked) return;

    dispatch(checkAuth(pathname));
    setIsChecked(true);
  }, [dispatch, isChecked, pathname]);

  useEffect(() => {
    if (isAdmin && appState === AuthStates.ALLOWED && pathname === "/login") {
      dispatch(replace("/home"));
      return;
    }
    if (!isAdmin && appState === AuthStates.ALLOWED && pathname === "/login")
      dispatch(replace("/sessions/verify-pin"));
  }, [isAdmin, appState, pathname, dispatch]);

  return appState;
};

export default useAuthProvider;
